module.exports = __webpack_public_path__ + "static/media/sort-circle-down.a0e7d470.svg";